var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnboardingIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0838 5.68799H9.93147C9.89338 5.68799 9.8553 5.72445 9.8553 5.76091V7.98505C9.8553 8.02151 9.89338 8.05798 9.93147 8.05798H10.0838C10.1219 8.05798 10.16 8.02151 10.16 7.98505V5.76091C10.16 5.72445 10.1219 5.68799 10.0838 5.68799Z",
    fill: "#7B7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7178 3.24483H23.5655C23.5274 3.24483 23.4893 3.2813 23.4893 3.31776V3.97406C23.4893 4.01052 23.5274 4.04698 23.5655 4.04698H23.7178C23.7559 4.04698 23.794 4.01052 23.794 3.97406V3.31776C23.775 3.2813 23.7559 3.24483 23.7178 3.24483Z",
    fill: "#7B7B7B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7178 4.72153H23.5655C23.5274 4.72153 23.4893 4.75799 23.4893 4.79445V6.12529C23.4893 6.16175 23.5274 6.19822 23.5655 6.19822H23.7178C23.7559 6.19822 23.794 6.16175 23.794 6.12529V4.77622C23.775 4.73976 23.7559 4.72153 23.7178 4.72153Z",
    fill: "#7B7B7B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7178 6.56284H23.5655C23.5274 6.56284 23.4893 6.5993 23.4893 6.63576V7.9666C23.4893 8.00306 23.5274 8.03952 23.5655 8.03952H23.7178C23.7559 8.03952 23.794 8.00306 23.794 7.9666V6.63576C23.775 6.5993 23.7559 6.56284 23.7178 6.56284Z",
    fill: "#7B7B7B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1189 9.51535L21.7565 8.96843C22.2135 8.84082 22.6895 9.02313 23.0513 9.02313C23.4512 9.0049 23.813 8.87728 24.0796 8.9502C24.9936 9.22366 24.8413 10.2628 23.9463 11.0467C22.7848 12.0859 21.2804 11.9036 21.2804 11.9036L20.1189 9.51535Z",
    fill: "#F5BA80"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8235 13.3445L22.5563 13.4721C23.0323 13.5268 23.3751 13.8914 23.7178 14.019C24.0987 14.1649 24.4795 14.1831 24.689 14.3472C25.4126 14.9488 24.8223 15.8421 23.6798 16.2249C22.1945 16.7172 20.8806 15.9879 20.8806 15.9879L20.8235 13.3445Z",
    fill: "#F5BA80"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3566 17.6831L23.0894 17.8107C23.5654 17.8654 23.9082 18.23 24.2509 18.3576C24.6318 18.5035 25.0126 18.5217 25.2221 18.6858C25.9457 19.2874 25.3554 20.1807 24.2128 20.5636C22.7276 21.0558 21.4137 20.3266 21.4137 20.3266L21.3566 17.6831Z",
    fill: "#F5BA80"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.26679 25.924L5.55181 16.1159L9.96952 7.38336C9.96952 7.38336 9.98856 6.79998 11.55 6.18014C13.0924 5.5603 14.749 14.9126 14.749 14.9126L16.0629 22.5148C16.0629 22.5148 15.5107 26.0333 12.921 28.458C10.3313 30.8827 9.47443 30.6275 9.47443 30.6275L8.69372 32.3776L2.29565 30.6275L3.26679 25.924Z",
    fill: "#F5BA80"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1882 15.0947L9.81721 16.9907L8.88416 17.3553L9.81721 9.68018L11.1882 15.0947Z",
    fill: "#EBA365"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7946 0H11.7214C10.6741 0 9.8363 0.82038 9.8363 1.80484V20.8924C9.8363 21.895 10.6932 22.6972 11.7214 22.6972H21.7946C22.8419 22.6972 23.6797 21.8768 23.6797 20.8924V1.80484C23.6797 0.82038 22.8228 0 21.7946 0Z",
    fill: "#666767"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8708 0.108887H11.6453C10.7122 0.108887 9.95056 0.838114 9.95056 1.73142V20.9465C9.95056 21.8398 10.7122 22.5691 11.6453 22.5691H21.8708C22.8038 22.5691 23.5655 21.8398 23.5655 20.9465V1.74965C23.5655 0.856344 22.8038 0.108887 21.8708 0.108887Z",
    fill: "#363332"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8707 0.692139H19.2429C19.1667 0.929137 19.2048 1.12967 19.0144 1.25729C18.9192 1.31198 18.7668 1.34844 18.5003 1.34844C17.3387 1.34844 16.1772 1.34844 15.0156 1.34844C14.73 1.34844 14.5776 1.31198 14.4824 1.23906C14.3301 1.12967 14.3491 0.929137 14.273 0.692139H11.6452C11.0359 0.692139 10.5408 1.16614 10.5408 1.74952V20.9646C10.5408 21.548 11.0359 22.022 11.6452 22.022H21.8707C22.48 22.022 22.9751 21.548 22.9751 20.9646V1.74952C22.9561 1.16614 22.461 0.692139 21.8707 0.692139Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6452 22.6969H16.0248C15.0156 25.8508 11.1501 26.3978 10.5027 26.5072C11.1501 25.1034 11.112 24.5747 11.569 22.6787C11.5881 22.6969 11.6262 22.6969 11.6452 22.6969Z",
    fill: "#EFAF77"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5967 26.2339C11.8928 31.0286 9.56965 31.9219 4.56165 28.8226C8.21768 29.3149 11.6643 28.294 14.5967 26.2339Z",
    fill: "#EFAF77"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0.582003 33.0155L2.84798 28.7495L5.68522 31.1924L4.35229 33.9999H1.21038C0.677212 33.9999 0.334459 33.4713 0.582003 33.0155Z",
    fill: "#F5BA80"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62757 32.8693L5.66626 31.192L6.25656 29.4966L9.49367 30.6269L8.42733 33.9996H7.43715L7.62757 32.8693Z",
    fill: "#EFAF77"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43707 33.9999H4.33325L5.66618 31.1924L7.62749 32.8696L7.43707 33.9999Z",
    fill: "#EFAF77"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9487 17.0633C16.0248 16.7351 15.9677 16.4434 15.8344 16.1882C16.1391 16.2793 16.4437 16.334 16.7675 16.3523C17.034 16.3705 17.2435 16.4799 17.3958 16.6622C17.472 16.8445 17.453 17.045 17.3577 17.1909C17.1864 17.4826 15.9487 17.0633 15.9487 17.0633Z",
    fill: "#F7D9BE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7404 22.0039H11.6452C11.6072 22.0039 11.55 22.0039 11.5119 22.0039C11.4548 21.6211 11.3596 21.2747 11.2454 20.983L13.359 18.6677C13.359 18.6677 14.1016 19.0323 15.4346 18.9047C15.625 18.8865 15.8154 18.8683 16.0249 18.8318C16.6532 18.7224 17.0722 18.4672 17.3197 18.1573C17.453 18.0114 17.5292 17.8473 17.5863 17.665C17.6053 17.9932 17.4911 18.5948 16.52 19.1053C16.1962 19.2693 15.8535 19.397 15.5298 19.4699C14.4825 19.7251 13.6256 19.5793 13.6256 19.5793L11.7404 22.0039Z",
    fill: "#363332"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8279 6.69375H21.1882C21.5344 6.69375 21.8286 6.27402 21.8286 5.72312V5.22063C21.8286 4.69596 21.5517 4.25 21.1882 4.25H12.8279C12.4818 4.25 12.1875 4.66973 12.1875 5.22063V5.74935C12.1875 6.27402 12.4818 6.69375 12.8279 6.69375Z",
    fill: "#A9A1CD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7426 9.5625H20.1736C20.4399 9.5625 20.6663 9.38001 20.6663 9.14049V8.92201C20.6663 8.6939 20.4532 8.5 20.1736 8.5H13.7426C13.4763 8.5 13.25 8.68249 13.25 8.92201V9.15189C13.25 9.38001 13.4763 9.5625 13.7426 9.5625Z",
    fill: "#A9A1CD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7426 11.6875H20.1736C20.4399 11.6875 20.6663 11.505 20.6663 11.2655V11.047C20.6663 10.8189 20.4532 10.625 20.1736 10.625H13.7426C13.4763 10.625 13.25 10.8075 13.25 11.047V11.2769C13.25 11.505 13.4763 11.6875 13.7426 11.6875Z",
    fill: "#A9A1CD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1783 20.7268H21.3755C21.7564 20.7268 22.0801 20.4351 22.0801 20.0523V18.3445C22.0801 17.9798 21.7754 17.6699 21.3755 17.6699H12.1783C11.7975 17.6699 11.4738 17.9616 11.4738 18.3445V20.0705C11.4738 20.4351 11.7975 20.7268 12.1783 20.7268Z",
    fill: "#A4FF00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.59054 27.4002C3.59054 27.4002 3.15258 23.7176 4.63785 21.7122C6.12311 19.7251 12.426 14.9304 12.426 14.9304C12.426 14.9304 12.8258 14.2741 13.7208 15.0033C14.6158 15.7143 15.6631 16.2977 16.7675 16.3524C17.9291 16.4071 18.1385 18.4489 16.0249 18.8318C14.3492 19.1235 13.359 18.6677 13.359 18.6677L11.2454 20.983C12.5212 24.064 10.7884 30.4082 6.37065 29.2962C4.14276 28.7128 3.59054 27.4002 3.59054 27.4002Z",
    fill: "#F5BA80"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0549 26.4157C10.6741 27.1813 9.77911 27.4366 8.90319 27.2543C8.75085 27.2178 8.69373 27.1996 8.69373 27.1996C8.69373 27.1996 10.4456 25.0848 10.5598 23.5534C10.6741 22.0221 10.5408 21.1105 10.5408 21.0012C10.5408 20.9829 10.5408 20.9829 10.5408 20.9829L12.8448 18.3759L13.1305 16.9175L13.4351 18.2301C13.4351 18.2301 14.0445 18.4124 15.3584 18.4671C15.4726 18.4671 15.5869 18.4671 15.7011 18.4853C16.4057 18.5035 16.9388 18.3395 17.3387 18.1754C17.0912 18.4853 16.6532 18.7405 16.0439 18.8499C15.8344 18.8864 15.644 18.9046 15.4536 18.9229C14.1397 19.0322 13.378 18.6859 13.378 18.6859L11.2644 21.0012C11.3786 21.2928 11.6071 22.0221 11.6643 22.4049C11.6643 22.569 11.9118 24.6837 11.0549 26.4157Z",
    fill: "#EBA365"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcon1);
export default __webpack_public_path__ + "static/media/onboarding-icon-1.16e7db133da18a8b428666f845dc2ab0.svg";
export { ForwardRef as ReactComponent };